import type { GifEncoderAdapter } from './encoders/GifEncoderAdapter'
import type { FrameRenderer } from './FrameRenderer'
import { createFrameTimeline } from './TimelineSampler'
import { GifExportJob } from './jobs/GifExportJob'
import type { GifExportJobInput } from './jobs/GifExportJob'
import type { NormalizedGifExportConfig } from './types'

export interface ExportPipelineDependencies {
  frameRenderer: FrameRenderer
}

export class ExportPipeline {
  constructor(private readonly dependencies: ExportPipelineDependencies) {}

  createGifJob(
    config: NormalizedGifExportConfig,
    input: GifExportJobInput,
    encoder: GifEncoderAdapter
  ): GifExportJob {
    return new GifExportJob(config, input, {
      frameRenderer: this.dependencies.frameRenderer,
      encoder,
      timeline: createFrameTimeline(config.duration, config.fps),
    })
  }
}
